
const key = "TAB_NAVIGATION"

export const TAB_NAVIGATION = {
        CLEAR: `${key}_CLEAR_TAB_NAVIGATION`,
        SET_TABS: `${key}_SET_TABS`,
};
